import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationBh4CycleCombined from "./index";

const MethylationBh4CycleWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationBh4CycleCombined}
    keyControlsId="methylation-bh4-cycle-key"
    {...props}
  />
);

export default MethylationBh4CycleWithToggleKey;
